<template>
		<div class="content home-page">
		<Header></Header>
			<div class="info crfff">
        <div class="" @click="back" style="width: 80px;height:80px;text-align: center;display: flex;align-items: center;justify-content: center;">
          <img width="50" src="../../static/images/back.png" />
        </div>
        <div class="fs50 mt50 ac">{{$t('PurchaseChances')}}</div>
        <div class="fs22 mt20 ac">{{$t('purchaseTips1')}} : {{score}}</div>
        <div class="list mt30">
          <div class="li" v-if="!isShow" @click="getSub('daily')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('Daily')}}<br />{{$t('Subscribe')}}</strong>
            </div>
            <div class="rf">
              {{$t('DailyKyats')}}
            </div>
          </div>
          <div class="li" v-if="!isShow" @click="getSub('weekly')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('Weekly')}}<br />{{$t('Subscribe')}}</strong>
            </div>
            <div class="rf">
              {{$t('WeeklyKyats')}}
            </div>
          </div>
          <div class="li" :class="{'disabled':!isShow}" @click="getBuy(1)">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('OneTime')}}<br />{{$t('Purchase')}}</strong>
            </div>
            <div class="rf">
              {{$t('OneTimeChance')}}
            </div>
          </div>
        </div>
			</div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal ac" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin:10px auto;font-size: 50px;    margin-right: -20px;">
                <img width="70" src="../../static/images/close.png" />
              </div>
              <div class="por" style="width: 340px;padding: 20px;margin: 0 auto;background: #1a266a;box-shadow: 0 0 30px #f4c214;border-radius: 100%;">
                <img width="300" src="../../static/images/img1.png" />
                <div class="circle"></div>
              </div>
              <div class="fs33 mt50 ac">{{$t('purchaseTips2')}}</div>
              <div class="fs26 ac" v-html="$t('purchaseTips3')"></div>
<!--              <div class="flex mt20" style="justify-content: center;">
                <img width="80" @click="getShao" src="../../static/images/shao.png" />
                <input type="number" style="background:#dadbe1;text-align: center;color:#1a266a;width: 160px;" v-model="num" class="input" />
                <img width="80" @click="getAdd" src="../../static/images/add.png" />
              </div>-->
              <button class="button mt30" @click="getBuy(2)">{{$t('BuyNow')}}!</button>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:true,
       score:'',
        num:1,
        info:{}
      }
    },
	created(){
		this.getHome();
	},
  methods: {
    getShao(){
      if(this.num==1){
        return;
      }
      this.num--
    },
    getAdd(){
      this.num++
    },
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/index/check_sub',null,r =>{
				that.$parent.returnCode(r,function(){
          that.isShow = r.data.sub_status
          that.score = r.data.score
					that.$parent.loadModal(false);
				});

			})

		},
    getSub(type){
      let that =this;
      let data = {
        type:type
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/sub',data,r =>{
      	that.$parent.returnCode(r,function(){
      		that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,50, 2000);
      	});

      })
    },
    getBuy(type){
      let that = this
      if(type==1){
        if(!that.isShow){
          return
        }
        that.num = 1
        that.$refs.imgDialog.showMaskFun();
      }else{
        let data = {
          num:this.num
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/index/buy',data,r =>{
        	that.$parent.returnCode(r,function(){
        		that.$parent.loadModal(false);
            that.$utils.alertText(r.msg,100,3000);
            that.$refs.imgDialog.closeMask();
            that.num = 1
            that.getHome()
        	});

        })
      }
    },
    closeTmgDialog(){
      this.$refs.imgDialog.closeMask();
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/purchaseChances.vue